import { render } from "./FunnyTransformButton.vue?vue&type=template&id=b8d27daa&scoped=true"
import script from "./FunnyTransformButton.vue?vue&type=script&lang=js"
export * from "./FunnyTransformButton.vue?vue&type=script&lang=js"

import "./FunnyTransformButton.vue?vue&type=style&index=0&id=b8d27daa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d27daa"]])

export default __exports__